/**
 * ScrollToTop — resets scroll position on route change.
 *
 * F-11 (dev review #34, generalised): the SPA preserved scroll position across
 * navigation, so pages opened mid-scroll (reported on /mental-health).
 * P3 #23: the document (window) is now the single scroll root on standard
 * pages; `main#main-content` only scrolls on the chat route. Both are reset
 * here so either scroll root lands at the top. Hash links are left alone so
 * in-page anchors still work.
 *
 * Mounted inside each <Router> in App.js. Renders nothing.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // anchor navigation — let the browser handle it
    const main = document.getElementById('main-content');
    if (main) main.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
